module.exports = __webpack_public_path__ + "img/20191221131930556.7a29a27e.jpg";